import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorrowerCreditComponent } from './borrower-credit/borrower-credit.component';
import { BorrowerCreditSmartComponent } from './borrower-credit-smart/borrower-credit-smart.component';
import { BorrowerOverviewModule } from 'app/borrower-overview/borrower-overview.module';
import { BorrowerCreditScoreSmartComponent } from './borrower-credit-score/borrower-credit-score-smart/borrower-credit-score-smart.component';
import { BorrowerCreditScoreComponent } from './borrower-credit-score/borrower-credit-score.component';
import { BorrowerDataTableModule } from 'app/borrower-data-table/borrower-data-table.module';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [
    BorrowerCreditComponent,
    BorrowerCreditSmartComponent,
    BorrowerCreditScoreComponent,
    BorrowerCreditScoreSmartComponent
  ],
  imports: [
    CommonModule,
    BorrowerDataTableModule,
    BorrowerOverviewModule,
    AlertModule,
    MatIconModule,
    MatDividerModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatTooltipModule,
  ],
  exports: [
    BorrowerCreditSmartComponent,
    BorrowerCreditScoreSmartComponent
  ]
})
export class BorrowerCreditModule { }
